import { Model } from 'app/model/backendmodel';
import { BaseAdapter } from 'app/model/adapters/base.adapter';
import { ILocationPath, Location } from 'shell-models-lib';
import { IFileConnectionLocationContext } from 'app/interfaces/copilot.pipeline.action.types';
import { isNil, omitBy } from 'lodash';

export abstract class FileLocationAdapter<T extends Location, U extends Model.DatasetLocation> extends BaseAdapter<
    T,
    U,
    IFileConnectionLocationContext
> {
    public override toFabricCopilotContext(location: T): IFileConnectionLocationContext {
        if (location) {
            const filePath = location.getParameterizedLocation();
            const result: IFileConnectionLocationContext = {
                Container: filePath.container,
                FolderPath: filePath.folderPath,
                Filename: filePath.fileName
            };
            return result;
        }
        return undefined;
    }

    public override fromFabricCopilotContext(context: IFileConnectionLocationContext, model: T): T {
        if (!model) {
            throw new Error(
                'Location should be initialized before calling FileLocationAdapter::fromFabricCopilotContext'
            );
        }
        if (context) {
            const filePath: ILocationPath = omitBy(
                {
                    container: context.Container,
                    folderPath: context.FolderPath,
                    fileName: context.Filename
                },
                (value) => isNil(value)
            ) as unknown as ILocationPath;
            model.setParameterizedLocation(filePath);
        }
        return model;
    }
}
